import { useCallback } from 'react'
import { useGameStore } from '../store/gameStore.js'
import { useUIStore } from '../store/uiStore.js'
import { coordKey, getTorpedoCells } from '@fleetduel/shared'
import type { Coord } from '@fleetduel/shared'

/**
 * GDD §7: Torpedo on already-revealed cells is allowed mechanically,
 * but the UI must warn the player before confirming.
 */
export function useWarning() {
  const checkTorpedoWarning = useCallback((target: Coord): boolean => {
    const { opponentBoard } = useGameStore.getState()
    const { torpedoDirection } = useUIStore.getState()

    const cells = getTorpedoCells(target, torpedoDirection)
    const revealedCells = cells.filter(c => {
      const state = opponentBoard.get(coordKey(c))
      return state && state !== 'unknown'
    })

    if (revealedCells.length > 0) {
      const msg = revealedCells.length === cells.length
        ? 'All torpedo target cells are already revealed. Fire anyway?'
        : 'Some torpedo target cells are already revealed. Fire anyway?'
      useUIStore.getState().showWarningMessage(msg)
      return true
    }

    return false
  }, [])

  return { checkTorpedoWarning }
}
